/* global  */ // tUrl等のグローバル変数を宣言する
// import Swiper from 'swiper' // Swiper
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill'
import { EffectFade, Autoplay, Pagination, Swiper } from 'swiper'
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

import scrollLock from './functions/_scrollLock.js' // スクロールロック
import autoScroll from './functions/_autoScroll'
Swiper.use([EffectFade, Autoplay, Pagination])

jQuery(function ($) {
  /*
          ###     ######  ######## #### ##     ## ########
         ## ##   ##    ##    ##     ##  ##     ## ##
        ##   ##  ##          ##     ##  ##     ## ##
       ##     ## ##          ##     ##  ##     ## ######
       ######### ##          ##     ##   ##   ##  ##
       ##     ## ##    ##    ##     ##    ## ##   ##
       ##     ##  ######     ##    ####    ###    ########
*/
  $(document).on('click', '.js-thisActive', function () {
    $(this).addClass('active')
  })

  /*
        ######   ######  ########   #######  ##       ##
       ##    ## ##    ## ##     ## ##     ## ##       ##
       ##       ##       ##     ## ##     ## ##       ##
        ######  ##       ########  ##     ## ##       ##
             ## ##       ##   ##   ##     ## ##       ##
       ##    ## ##    ## ##    ##  ##     ## ##       ##
        ######   ######  ##     ##  #######  ######## ########
*/
  $(document).on('click', '.js-scroll', function () {
    const target = $(this).data('scroll-target')

    autoScroll(target, 0, true)
  })

  /*
        ######  ##       #### ########  ########
       ##    ## ##        ##  ##     ## ##
       ##       ##        ##  ##     ## ##
        ######  ##        ##  ##     ## ######
             ## ##        ##  ##     ## ##
       ##    ## ##        ##  ##     ## ##
        ######  ######## #### ########  ########
*/
  /*
               ##     ## ##     ##
               ###   ### ##     ##
               #### #### ##     ##
       ####### ## ### ## ##     ##
               ##     ##  ##   ##
               ##     ##   ## ##
               ##     ##    ###
*/
  if (document.getElementById('mv-slide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('#mv-slide', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      fadeEffect: {
        crossFade: true, // クロスフェード
      },
      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--mv', // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
    })
  }

  /*
                ######  ########    ###    ######## ########
               ##    ##    ##      ## ##   ##       ##
               ##          ##     ##   ##  ##       ##
       #######  ######     ##    ##     ## ######   ######
                     ##    ##    ######### ##       ##
               ##    ##    ##    ##     ## ##       ##
                ######     ##    ##     ## ##       ##
*/
  function staffSlider() {
    if (document.getElementById('staff-slide')) {
      // Swiperコンテナを検出したら実行
      // eslint-disable-next-line no-unused-vars
      const mvSwiper = new Swiper('#staff-slide', {
        effect: 'fade', // slide,fade,cube,coverflow
        speed: 1000, // アニメ速度
        loop: true, // ループ
        fadeEffect: {
          crossFade: true, // クロスフェード
        },
        autoplay: {
          // オートオプション
          delay: 5000, // 待機時間
          disableOnInteraction: false, // 操作されたらオート解除
        },
        pagination: {
          // ページャーオプション
          el: '.swiper-pagination--staff', // ページャーを呼び出す要素
          type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
          clickable: true, // クリックでジャンプ可能にする
        },
      })
    }
  }
  staffSlider()

  /*
       ######## ########     ###     ######  ########
          ##    ##     ##   ## ##   ##    ## ##
          ##    ##     ##  ##   ##  ##       ##
          ##    ########  ##     ## ##       ######
          ##    ##   ##   ######### ##       ##
          ##    ##    ##  ##     ## ##    ## ##
          ##    ##     ## ##     ##  ######  ########
*/
  // 指定のテキストを他の箇所に写す
  $(document).on('click', '.js-trace', function () {
    const text = $(this).text()
    const target = $(this).data('trace-target')
    $('.js-trace--' + target).text(text)
  })

  /*
          ###     ######   ######
         ## ##   ##    ## ##    ##
        ##   ##  ##       ##
       ##     ## ##       ##
       ######### ##       ##
       ##     ## ##    ## ##    ##
       ##     ##  ######   ######
*/
  // チェックボックス型のアコーディオンを閉じる
  $(document).on('click', '.js-acc-close', function () {
    $('.acc-check').prop({ checked: false })
  })

  /*
          ###          ##    ###    ##     ##
         ## ##         ##   ## ##    ##   ##
        ##   ##        ##  ##   ##    ## ##
       ##     ##       ## ##     ##    ###
       ######### ##    ## #########   ## ##
       ##     ## ##    ## ##     ##  ##   ##
       ##     ##  ######  ##     ## ##     ##
*/
  /*
               ######## #### ##       ######## ######## ########
               ##        ##  ##          ##    ##       ##     ##
               ##        ##  ##          ##    ##       ##     ##
       ####### ######    ##  ##          ##    ######   ########
               ##        ##  ##          ##    ##       ##   ##
               ##        ##  ##          ##    ##       ##    ##
               ##       #### ########    ##    ######## ##     ##
*/
  $(document).on('click', '.js-clickAjax', function () {
    const item = $(this)
    const name = item.data('ajax-name')
    const id = item.data('ajax-id')
    const pair = item.data('ajax-pair')
    const pairID = $('[name ="' + pair + '"]').val()
    const from = item.data('ajax-from')
    const to = item.data('ajax-to')

    const data = {
      search: 1,
    }

    data[name] = id
    if (pairID) {
      data[pair] = parseInt(pairID, 10)
    }

    $(to).html('<div class="md-loading active"></div>')

    $.ajax({
      url: './',
      type: 'GET',
      data: data,
    })
      .done((data) => {
        const outHtml = $($.parseHTML(data)) //parse
        $(to).html(outHtml.find(from)[0].innerHTML)
        // history.replaceState(null, null, url) // URL変更
        autoScroll('#search', 0, true)
      })
      .fail((data) => {
        // Ajaxリクエストが失敗
      })
      .always((data) => {
        // 成功・失敗どちらでも発動
        $('.js-active').addClass('active')
      })
  })

  /*
               ##     ##  #######  ########     ###    ##
               ###   ### ##     ## ##     ##   ## ##   ##
               #### #### ##     ## ##     ##  ##   ##  ##
       ####### ## ### ## ##     ## ##     ## ##     ## ##
               ##     ## ##     ## ##     ## ######### ##
               ##     ## ##     ## ##     ## ##     ## ##
               ##     ##  #######  ########  ##     ## ########
*/
  $(document).on('click', '.js-ajaxModal', function () {
    const item = $(this)
    const url = item.attr('href') + '?modal=1'
    const modal = item.data('ajax-modal')
    const from = item.data('ajax-from')
    const to = item.data('ajax-to')

    event.preventDefault()

    $('.js-modal--' + modal).addClass('active')
    $(to).html('<div class="md-loading flex vcenter hcenter active"></div>')

    $.ajax({
      url: url,
      dataType: 'html',
    })
      .done((data) => {
        const outHtml = $($.parseHTML(data)) //parse
        $(to).html(outHtml.find(from)[0].innerHTML)
        // history.replaceState(null, null, url) // URL変更
        $('#modalOverlay').addClass('active')
        scrollLock('html,body', '#modalOverlay')
        staffSlider()
      })
      .fail((data) => {
        // Ajaxリクエストが失敗
        // モーダル撤去
      })
      .always((data) => {
        // 成功・失敗どちらでも発動
      })
  })

  // モーダル撤去
  $(document).on('click ', '.js-modal--close', function () {
    $('.js-modal').removeClass('active')
    $('#modalOverlay').removeClass('active')
    $('.js-modal-content').html('')
    scrollLock('html,body', '#modalOverlay')
  })
})
